import React, { useEffect, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../css/about.css';

const AgencyTemplate = ({ 
  title, 
  subtitle, 
  description, 
  image, 
  imageAlt,
  features = [],
  additionalSections = [],
  companyInfo = null
}) => {
  const underlineRef = useRef(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (underlineRef.current) {
        underlineRef.current.classList.add('animate');
      }
    }, 50);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {/* Hero Section */}
      <div className="container-fluid about-bg d-flex align-items-end" style={{ minHeight: '85vh', padding: 0, top: '-122px' }}>
        <div className="container about-content py-5">
          <div className="row">
            <div className="col-lg-8 col-md-10 col-12">
              <h1 className="about-title display-4 fw-bold">{title}</h1>
              <h2 className="about-subtitle h4">{subtitle}</h2>
              <div className="about-underline mt-2" ref={underlineRef}></div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content Section */}
      <section className="py-5 bg-white">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              
              {/* Company Overview Card */}
              <div className="card shadow-sm border-0 mb-5">
                <div className="card-body p-4 p-md-5">
                  <div className="row g-4 align-items-center">
                    <div className="col-md-8">
                      <p className="mb-0">{description}</p>
                    </div>
                    <div className="col-md-4">
                      <div className="card border-0 shadow-sm h-100">
                        <div className="ratio ratio-4x3 d-md-block d-none" style={{ backgroundColor: '#fff' }}>
                          <img
                            src={image}
                            alt={imageAlt}
                            className="img-fluid"
                            style={{ objectFit: 'contain' }}
                          />
                        </div>
                        <img
                          src={image}
                          alt={imageAlt}
                          className="img-fluid d-md-none"
                          style={{ objectFit: 'contain' }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Features Section */}
              {features.length > 0 && (
                <div className="row g-4 mb-5">
                  {features.map((feature, index) => (
                    <div key={index} className="col-md-6">
                      <div className="card h-100 shadow-sm border-0">
                        <div className="card-body p-4">
                          <h5 className="card-title mb-3">
                            <i className={`${feature.icon} me-2`} style={{ color: feature.iconColor || '#0c61c0' }}></i>
                            {feature.title}
                          </h5>
                          <p className="card-text mb-0">{feature.description}</p>
                          {feature.benefits && (
                            <div className="mt-3">
                              <h6 className="text-muted mb-2">Key Benefits</h6>
                              <ul className="list-group list-group-flush">
                                {feature.benefits.map((benefit, benefitIndex) => (
                                  <li key={benefitIndex} className="list-group-item px-0">
                                    <i className={`${benefit.icon} me-2`} style={{ color: benefit.iconColor || '#28a745' }}></i>
                                    {benefit.text}
                                  </li>
                                ))}
                              </ul>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {/* Additional Sections */}
              {additionalSections.map((section, index) => (
                <div key={index} className="card shadow-sm border-0 mb-4">
                  <div className="card-body p-4">
                    <h4 className="mb-3">{section.title}</h4>
                    {section.content && <p className="mb-3">{section.content}</p>}
                    {section.items && (
                      <div className="row g-3">
                        {section.items.map((item, itemIndex) => (
                          <div key={itemIndex} className="col-md-6">
                            <ul className="list-group list-group-flush">
                              {item.map((listItem, listIndex) => (
                                <li key={listIndex} className="list-group-item px-0">
                                  <i className={`${listItem.icon} me-2`} style={{ color: listItem.iconColor || '#0c61c0' }}></i>
                                  <strong>{listItem.title}</strong>
                                  {listItem.description && `: ${listItem.description}`}
                                </li>
                              ))}
                            </ul>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              ))}

              {/* Company Info Section */}
              {companyInfo && (
                <div className="card shadow-sm border-0">
                  <div className="card-body p-4">
                    <h4 className="mb-3">{companyInfo.title}</h4>
                    <p className="mb-0">{companyInfo.description}</p>
                  </div>
                </div>
              )}

            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AgencyTemplate;







